import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Uploads a file to the backend object storage and returns a full, displayable URL.
export async function uploadFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API_URL}/api/upload`, fd, { withCredentials: true });
  // Backend returns a relative path like /api/files/...; prefix with backend URL for <img src>.
  const url = res.data.url || '';
  return url.startsWith('http') ? url : `${API_URL}${url}`;
}
